import React from "react"
import Components from ".."
import { blokType } from "../../types"
import {
  StyledFixedHeaderContainer,
  StyledFixedHeaderWrapper,
  StyledFixedHeader,
  StyledMobileLogo,
  StyledLogo,
  StyledButton,
} from "./partials"

import shield from "../../assets/images/hult-icon.svg"
import hult_logo from "../../assets/images/logo.svg"

export interface FixedHeaderProps {
  cta_button: blokType[]
  background_color: string
}

export const FixedHeaderCmp: React.FC<FixedHeaderProps> = ({
  cta_button,
  background_color,
}) => {
  return (
    <StyledFixedHeaderContainer>
      <StyledFixedHeaderWrapper background_color={background_color}>
        <StyledFixedHeader>
          <StyledMobileLogo href="/">
            <img alt="Hult Logo" src={shield} />
          </StyledMobileLogo>
          <StyledLogo href="/">
            <img alt="Hult Logo" src={hult_logo} />
          </StyledLogo>
          <StyledButton>
            {cta_button && cta_button.length > 0 && (
              <>
                {cta_button.map((content) =>
                  React.createElement(Components(content.component), {
                    key: content._uid,
                    blok: content,
                  })
                )}
              </>
            )}
          </StyledButton>
        </StyledFixedHeader>
      </StyledFixedHeaderWrapper>
    </StyledFixedHeaderContainer>
  )
}
